<span class="tezos-symbol">{{ tezosString }}</span>